import {ACTIONS} from '../../actions/auth.actions';

const initialState = {
  fetchInProgress: false,
  featchError: '',
  refreshInProgress: false,
  token: window.localStorage.getItem('auth_token'),
  companyId: window.localStorage.getItem('companyId'),
  company: window.localStorage.getItem('company'),
  companyRole: window.localStorage.getItem('companyRole'),
  refresh_token: window.localStorage.getItem('refresh_token'),
  expiryDate: window.localStorage.getItem('expiryDate')? parseInt(window.localStorage.getItem('expiryDate'),10) : 0,
  roles: window.localStorage.getItem('expiryDate')? JSON.parse(window.localStorage.getItem('roles')) : []
}

export default (state = initialState,action) => {

  switch(action.type){

    case ACTIONS.LoginInProgress: {
      return {
        ...state,
        fetchInProgress: true,
        fetchError: '',
        token: '',
        companyId: '',
        company: '',
        username: action.payload.username
      };
    }

    case ACTIONS.LoginFailed: {
      return {
        ...state,
        fetchInProgress: false,
        fetchError: JSON.parse(action.payload).message,
        token: '',
        companyId: '',
        company: '',
        username: '',
      };
    }

    case ACTIONS.LoginCompleted: {

      let expiryDate = new Date().getTime() + action.payload.expires_in * 1000;
      window.localStorage.setItem('auth_token', action.payload.token);
      window.localStorage.setItem('companyId', action.payload.companyId);
      window.localStorage.setItem('company', action.payload.company);
      window.localStorage.setItem('refresh_token', action.payload.refresh_token);
      window.localStorage.setItem('companyRole', action.payload.companyRole);
      window.localStorage.setItem('expiryDate', expiryDate.toString());
      window.localStorage.setItem('roles', JSON.stringify(action.payload.roles));

      return {
        ...state,
        fetchInProgress: false,
        fetchError: '',
        token: action.payload.token,
        companyId: action.payload.companyId,
        company: action.payload.company,
        companyRole: action.payload.companyRole,
        roles: action.payload.roles
      }
    }

    case ACTIONS.TokenRefreshInProgress: {
      return {
        ...state,
        refreshInProgress: true,
        fetchError: ''
      }
    }
    case ACTIONS.LoginRedirect: {
      return { 
        ...state,
        fetchInProgress: false
      }
    }

    case ACTIONS.TokenRefreshFailed: {
      window.localStorage.setItem('auth_token', '');
      window.localStorage.setItem('refresh_token', '');
      window.localStorage.setItem('expiryDate', '');
      window.localStorage.setItem('companyId', '');
      window.localStorage.setItem('company', '');
      window.localStorage.setItem('companyRole', '');
      window.localStorage.setItem('roles', '');
      return {
        ...state,
        token: '',
        refreshInProgress: false,
        refresh_token: '',
        expiryDate: 0,
        companyId: '',
        company: '',
        fetchError: action.payload
      }
    }

    case ACTIONS.TokenRefreshCompleted: {
      let expiryDate = new Date().getTime() + action.payload.expires_in * 1000;
      window.localStorage.setItem('auth_token', action.payload.token);
      window.localStorage.setItem('refresh_token', action.payload.refresh_token);
      window.localStorage.setItem('expiryDate', expiryDate.toString());
      return {
        ...state,
        token: action.payload.token,
        refresh_token: action.payload.refresh_token,
        expiryDate: expiryDate,
        refreshInProgress: false
      }
    }

    case ACTIONS.Logout: {
      window.localStorage.setItem('auth_token', '')
      window.localStorage.setItem('refresh_token', '');
      window.localStorage.setItem('expiryDate', '');
      window.localStorage.setItem('companyId', '');
      window.localStorage.setItem('company', '');
      window.localStorage.setItem('roles', '');
      return {
        ...state,
        token: '',
        refresh_token: '',
        expiryDate: '',
        refreshInProgress: false,
        companyId: '',
        company: '',
      }
    }

    case ACTIONS.LoadCompanyCompleted: {
      return {
        ...state,
        companyData: action.payload,
        fetchInProgress: false
      }
    }

    case ACTIONS.LoadCompanyInProgress: {
      return {
        ...state,
        companyData: null,
        fetchInProgress: true
      }
    }

    case ACTIONS.LoadCompanyFailed: {
       return {
        ...state,
        companyData: null,
        fetchInProgress: false,
        fetchError: action.payload
      }
    }

    default: 
      return state;
  }


};


// WEBPACK FOOTER //
// ./src/reducers/auth/index.js